import { unpaidInvoiceTasks } from "./services/unpaid-invoices.mjs";
import { todayParis } from "./crm.mjs";
export function shiftDate(value, offset) {
  const date = new Date(`${value}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + offset);
  return date.toISOString().slice(0, 10);
}
export function weekStart(value) {
  const day = new Date(`${value}T12:00:00Z`).getUTCDay();
  return shiftDate(value, -((day + 6) % 7));
}
export function dashboardMetrics(state, date, isHyperadmin = false) {
  const start = weekStart(date),
    end = shiftDate(start, 7);
  const weekResults = state.results.filter((r) => {
    const day = todayParis(new Date(r.createdAt));
    return day >= start && day < end;
  });
  const todayResults = state.results.filter(
    (r) => todayParis(new Date(r.createdAt)) === date,
  );
  const tasks = [...state.tasks.filter(
    (t) =>
      !t.done &&
      (isHyperadmin || t.category !== "manager") &&
      t.due_date_original <= date,
  ), ...unpaidInvoiceTasks(state, date)];
  const contacted = new Set(state.results.map((r) => r.clientId));
  const stageFor = (client) => {
    const needs = state.needs.filter(
      (n) =>
        n.clientId === client.id && !["perdu", "suspendu"].includes(n.status),
    );
    if (needs.some((n) => n.transmittedAt || n.status === "signé"))
      return "Signé";
    if (needs.length) return "Besoin";
    return contacted.has(client.id) ? "Contacté" : "À contacter";
  };
  const stages = [
    "À contacter",
    "Contacté",
    "Besoin",
    "Signé",
  ].map((label) => ({
    label,
    clients: state.clients.filter((c) => stageFor(c) === label),
  }));
  return {
    tasks,
    todayResults,
    weekResults,
    stages,
    overdue: tasks.filter((t) => t.due_date_original < date).length,
    newProspects: state.clients.filter(
      (c) => c.kind === "prospect" && !contacted.has(c.id),
    ).length,
    dueQuotes: state.needs.filter((n) => n.status === "devis envoyé").length,
  };
}
